import RateCard from "./RateCard";
import { WEEKDAYS } from "../utils/pricingDefaults";

const StopSaleSection = ({
  categoryId,
  isEnabled,
  stopSales,
  stopSaleDates,
  selectedDays,
  colors,
  calculateBalance,
  formatDate,
  weekdays,
  onStopSaleDateChange,
  onDayToggle,
  onAllDaysToggle,
  onSubmitStopSale,
  onEditStopSale,
  onDeleteStopSale,
  isSubmittingStopSale,
}) => {
  const categoryStopSales = stopSales.filter(
    (s) => s.package_stay_category_id === categoryId
  );

  return (
    <section
      className={`rounded-xl border border-gray-100 bg-slate-50/40 p-5 ${
        !isEnabled ? "opacity-40 pointer-events-none" : ""
      }`}
    >
      <div className="mb-4">
        <h3 className="text-sm font-bold text-gray-900">Stop sale</h3>
        <p className="text-sm text-gray-500 mt-0.5">
          Block bookings for specific dates and weekdays.
        </p>
      </div>

      {!isEnabled && (
        <p className="text-sm text-amber-600 mb-3">
          Complete base price for this stay category to add stop sales.
        </p>
      )}

      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Start date
            </label>
            <input
              type="date"
              name="startDate"
              min={new Date().toISOString().split("T")[0]}
              value={stopSaleDates?.startDate || ""}
              onChange={onStopSaleDateChange}
              className="w-full h-10 border rounded-md px-3 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              End date
            </label>
            <input
              type="date"
              name="endDate"
              min={stopSaleDates?.startDate || ""}
              value={stopSaleDates?.endDate || ""}
              onChange={onStopSaleDateChange}
              className="w-full h-10 border rounded-md px-3 text-sm"
            />
          </div>
        </div>

        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-medium text-gray-700">Days</span>
            <button
              type="button"
              onClick={onAllDaysToggle}
              className="text-xs px-2 py-0.5 rounded bg-gray-100 hover:bg-gray-200"
            >
              {selectedDays.length === WEEKDAYS.length ? "Clear all" : "All days"}
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {WEEKDAYS.map(({ day, full }) => (
              <button
                key={day}
                type="button"
                onClick={() => onDayToggle(day)}
                title={full}
                className={`px-3 py-1 text-xs rounded-full border ${
                  selectedDays.includes(day)
                    ? "bg-red-50 text-red-700 border-red-200"
                    : "bg-gray-50 border-gray-200"
                }`}
              >
                {day}
              </button>
            ))}
          </div>
        </div>

        <button
          type="button"
          onClick={onSubmitStopSale}
          disabled={
            isSubmittingStopSale ||
            !stopSaleDates?.startDate ||
            !stopSaleDates?.endDate ||
            selectedDays.length === 0
          }
          className="w-full sm:w-auto px-4 py-2 text-sm font-medium bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
        >
          {isSubmittingStopSale ? "Adding…" : "Add stop sale"}
        </button>
      </div>

      {categoryStopSales.length > 0 && (
        <div className="mt-5 border border-gray-100 rounded-lg divide-y divide-gray-50">
          {categoryStopSales.map((stopSale) => (
            <RateCard
              key={stopSale.id}
              rate={stopSale}
              colors={colors}
              calculateBalance={calculateBalance}
              formatDate={formatDate}
              weekdays={weekdays}
              isStopSale
              onEdit={onEditStopSale}
              onDelete={onDeleteStopSale}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default StopSaleSection;
